import React from 'react';

import './BetslipPopup.scss';

interface BetslipPopupMessageProps {
  content: string
}

export default function BetslipPopupMessage({ content }: BetslipPopupMessageProps) {

  return (
    <div className="betslip-popup__content">
      <div className="betslip-popup__text"> { content } </div>
    </div>
  );
}
